/**
 * The name a saved media file has, in the cloud and in the local folder alike: its category and
 * the time it was made (`sketches_1734567890.png`). Both copies must have the same name, as the
 * local copy is looked for by the cloud copy's name; this is the one place that name is made.
 * Kept apart from fileRegistry (which starts Firebase) and localSave, so both can use it.
 */
export const mediaFileName = (category: string, timestamp: number, extension: string): string =>
    `${category.toLowerCase()}_${timestamp}.${extension}`;
